var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.headerActionConfig, page: _vm.pageOptions }
      }),
      _c(
        "validation-observer",
        { ref: "accountNumberRef", attrs: { novalidate: "", tag: "form" } },
        [
          _c(
            "div",
            [
              _c("section-title", {
                attrs: { "has-line": "", title: "Añadir Cifras de Cuentas" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "bg-secondary-1 p-3 rounded" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-date-picker", {
                              attrs: {
                                "custom-error-msg":
                                  "Favor seleccionar la fecha desde.",
                                error: errors[0],
                                label: "Fecha Desde:",
                                placeholder: "DD/MM/YYYY"
                              },
                              model: {
                                value: _vm.model.dateFrom,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "dateFrom", $$v)
                                },
                                expression: "model.dateFrom"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm.validations.invalidDate
                    ? _c("error", {
                        attrs: {
                          message: _vm.validations.invalidDate,
                          variant: "no-border mt-1"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-date-picker", {
                              attrs: {
                                "custom-error-msg":
                                  "Favor seleccionar la fecha hasta.",
                                error: errors[0],
                                label: "Fecha Hasta:",
                                placeholder: "DD/MM/YYYY"
                              },
                              model: {
                                value: _vm.model.dateTo,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "dateTo", $$v)
                                },
                                expression: "model.dateTo"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                clearable: false,
                                "custom-error-msg":
                                  "Favor seleccionar el Tipo de Contratación.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Tipo de Contratación:",
                                options: _vm.catalog.hiringTypes,
                                placeholder: "Seleccione"
                              },
                              on: { input: _vm.onChangeHiringTypeHandler },
                              model: {
                                value: _vm.model.hiringType,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "hiringType", $$v)
                                },
                                expression: "model.hiringType"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                clearable: false,
                                "custom-error-msg":
                                  "Favor seleccionar el Tipo de Cifra.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Tipo de Cifra:",
                                options: _vm.catalog.figureTypes,
                                placeholder: "Seleccione"
                              },
                              on: { input: _vm.onNumberTypeHandler },
                              model: {
                                value: _vm.model.figureType,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "figureType", $$v)
                                },
                                expression: "model.figureType"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules:
                        _vm.isProfessionalService && _vm.isFederalAccounting
                          ? "required"
                          : ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                id: "serviceId",
                                clearable: false,
                                "custom-error-msg":
                                  "Favor seleccionar el Grupo de Edad.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Grupo de Edad:",
                                options: _vm.catalog.billingServiceCategories,
                                placeholder: "Seleccione"
                              },
                              model: {
                                value: _vm.model.serviceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "serviceId", $$v)
                                },
                                expression: "model.serviceId"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]),
            _vm.isAssistiveTeam
              ? _c("div", { staticClass: "row py-4" }, [
                  _c(
                    "div",
                    { staticClass: "col border-right pr-4" },
                    [
                      _c(
                        "validation-observer",
                        {
                          ref: "caatDropDown",
                          attrs: { disabled: true, novalidate: "", tag: "form" }
                        },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: "caat",
                                          clearable: false,
                                          "custom-error-msg":
                                            "El centro de servicio es requerido.",
                                          error: errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label: "Centro de Servicio:",
                                          options: _vm.availableCaatOptions,
                                          placeholder: "Seleccione"
                                        },
                                        on: { input: _vm.onChangeCaatHandler },
                                        model: {
                                          value: _vm.model.caat,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "caat", $$v)
                                          },
                                          expression: "model.caat"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              481275984
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end mt-2" },
                        [
                          _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-file-plus",
                                variant: "success"
                              },
                              on: { click: _vm.onAddCaatHandler }
                            },
                            [_vm._v(" Añadir ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col pl-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-gray-6 font-16 font-weight-normal mb-2"
                        },
                        [_vm._v(" Centro de Servicio Seleccionados ")]
                      ),
                      _vm._l(_vm.model.caats, function(caat, index) {
                        return _c(
                          "div",
                          {
                            key: `caat-row-${index}`,
                            staticClass: "chip ml-0 bg-white"
                          },
                          [
                            _c("span", { staticClass: "mr-2" }, [
                              _vm._v(_vm._s(caat.name))
                            ]),
                            _c("em", {
                              staticClass:
                                "far fa-lg fa-times-circle color-red cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.removeCaatHandler(index)
                                }
                              }
                            })
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            !!_vm.model.hiringType && !!_vm.model.figureType
              ? _c("div", { staticClass: "bg-white p-3 mt-3 rounded" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Es requerido Account.",
                                        error: errors[0],
                                        label: "Account:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.account,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "account", $$v)
                                        },
                                        expression: "model.account"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3201951448
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Es requerido Dept.",
                                        error: errors[0],
                                        label: "Dept:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.dept,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "dept", $$v)
                                        },
                                        expression: "model.dept"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2461541436
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Es requerido Fund.",
                                        error: errors[0],
                                        label: "Fund:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.fund,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "fund", $$v)
                                        },
                                        expression: "model.fund"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            934382240
                          )
                        })
                      ],
                      1
                    ),
                    _vm.isAssistiveTeam && !_vm.isFederalAccounting
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Es requerido Program.",
                                            error: errors[0],
                                            label: "Program:",
                                            type: "text"
                                          },
                                          model: {
                                            value: _vm.model.program,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "program",
                                                $$v
                                              )
                                            },
                                            expression: "model.program"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3847242029
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Es requerido Class.",
                                        error: errors[0],
                                        label: "Class:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.class,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "class", $$v)
                                        },
                                        expression: "model.class"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3717410647
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Es requerido Bud Ref.",
                                        error: errors[0],
                                        label: "Bud Ref:",
                                        type: "number"
                                      },
                                      model: {
                                        value: _vm.model.budRef,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "budRef", $$v)
                                        },
                                        expression: "model.budRef"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4070923141
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Es requerido PC Bus Unit.",
                                        error: errors[0],
                                        label: "PC Bus Unit:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.pcBusUnit,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "pcBusUnit", $$v)
                                        },
                                        expression: "model.pcBusUnit"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3614791816
                          )
                        })
                      ],
                      1
                    ),
                    (_vm.isProfessionalService || _vm.isAssistiveTeam) &&
                    _vm.isFederalAccounting
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Es requerido Project.",
                                            error: errors[0],
                                            label: "Project:",
                                            type: "text"
                                          },
                                          model: {
                                            value: _vm.model.project,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "project",
                                                $$v
                                              )
                                            },
                                            expression: "model.project"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2208444268
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isAssistiveTeam && _vm.isFederalAccounting
                      ? _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Es requerido Activity.",
                                            error: errors[0],
                                            label: "Activity:",
                                            type: "text"
                                          },
                                          model: {
                                            value: _vm.model.activity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "activity",
                                                $$v
                                              )
                                            },
                                            expression: "model.activity"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1945962772
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]),
          !!_vm.model.figureType
            ? _c(
                "div",
                { staticClass: "mt-4 mb-n2" },
                [
                  _c("custom-callout", { staticClass: "mb-3 custom-callout" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Número de Cifra: ")
                    ]),
                    _c(
                      "div",
                      { staticClass: "font-weight-normal color-black font-16" },
                      [_vm._v(" " + _vm._s(_vm.fullNumber) + " ")]
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm.isDetailView
        ? _c(
            "div",
            { staticClass: "col-md-12 mt-4" },
            [
              _c("section-title", {
                attrs: { "has-line": "", title: "Utilización de Fondos" }
              }),
              _c("custom-callout", { staticClass: "mb-3 custom-callout" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 border-right d-flex",
                      class: _vm.editProjectedFund ? "col-md-3" : "col-md-2"
                    },
                    [
                      _c("div", { staticClass: "mr-3 w-100" }, [
                        _c(
                          "div",
                          { staticClass: "color-secondary-6 font-14" },
                          [_vm._v("Fondo Proyectado:")]
                        ),
                        !_vm.editProjectedFund
                          ? _c(
                              "div",
                              { staticClass: "font-weight-bold font-16" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.fundsUse.projectedFund
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "d-flex w-100" },
                              [
                                _c(
                                  "validation-observer",
                                  {
                                    ref: "formProjectedFundRef",
                                    attrs: { novalidate: "", tag: "form" }
                                  },
                                  [
                                    _c("validation-provider", {
                                      staticClass: "input",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  attrs: {
                                                    id: "inputProjectedFund",
                                                    "custom-error-msg":
                                                      "El fondo proyectado es requerido.",
                                                    error: errors[0],
                                                    "mask-type": "Money"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.projectedFundValue,
                                                    callback: function($$v) {
                                                      _vm.projectedFundValue = $$v
                                                    },
                                                    expression:
                                                      "projectedFundValue"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        4001575165
                                      )
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "ml-2" },
                                  [
                                    _c("action-button", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        i: "fas fa-times-circle",
                                        variant: "outline-danger"
                                      },
                                      on: {
                                        click: _vm.onEditProjectedFundHandler
                                      }
                                    }),
                                    _c("action-button", {
                                      attrs: {
                                        i: "fas fa-save",
                                        variant: "success"
                                      },
                                      on: {
                                        click: _vm.onSumbmitProjectedFundHandler
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                      ]),
                      !_vm.editProjectedFund
                        ? _c("action-button", {
                            attrs: { i: "fas fa-edit", variant: "success" },
                            on: { click: _vm.onEditProjectedFundHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-12 col-md-2" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v("Fondo Asignado:")
                    ]),
                    _c(
                      "div",
                      { staticClass: "font-weight-bold color-green font-16" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(_vm.fundsUse.assignedFunds)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "col-12 col-md-2" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v("Contratados:")
                    ]),
                    _c(
                      "div",
                      { staticClass: "font-weight-bold color-black font-16" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(_vm.fundsUse.contracted)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "col-12 col-md-2" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v("Proceso de Pago:")
                    ]),
                    _c(
                      "div",
                      { staticClass: "font-weight-bold color-black font-16" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(_vm.fundsUse.paymentProcess)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "col-12",
                      class: _vm.editProjectedFund ? "col-md-1" : "col-md-2"
                    },
                    [
                      _c("div", { staticClass: "color-secondary-6 font-14" }, [
                        _vm._v("Pagado:")
                      ]),
                      _c(
                        "div",
                        { staticClass: "font-weight-bold color-black font-16" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("currency")(_vm.fundsUse.paid)) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "col-12 col-md-2" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v("Disponible:")
                    ]),
                    _vm.fundsUse.available > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "font-weight-bold color-green font-16"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("currency")(_vm.fundsUse.available)
                                ) +
                                " "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.fundsUse.available <= 0
                      ? _c(
                          "div",
                          { staticClass: "font-weight-bold color-red font-16" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("currency")(_vm.fundsUse.available)
                                ) +
                                " "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }